import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  KeyValuePair,
} from '@/shared/shared.types';
import { Field, RichTextField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C33IconCTALeftAlignedCardProps = RenderingProps<
  C33IconCTALeftAlignedCardFields,
  C33IconCTALeftAlignedCardRenderingParams
>;

export type C33IconCTALeftAlignedCardRenderingParams = {
  HeadlineTag?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C33IconCTALeftAlignedCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CardCTA?: LinkField;
};
